import { mount } from '../../dom-lifecycle';

mount('#reset-password-form', function (form) {
    const formPanel = document.getElementById('js-reset-form-panel');
    const successPanel = document.getElementById('js-reset-success-panel');

    $(form).on('submit-success', function (event) {
        event.preventDefault();
        if (formPanel) formPanel.style.display = 'none';
        if (successPanel) successPanel.style.display = '';
    });
});
